export const getEmailLink = (v?: string) => (v ? `mailto:${v}` : '');
